import { connect, MapStateToProps } from "react-redux";

import { getEnumType } from "@multiweb/reactCore/enums";
import { IAppState } from "@multiweb/types/react";
import { EnumProviderComponent, EnumProviderComponentChildrenProps } from "./EnumProviderComponent";

export type EnumProviderProps = {
    /** Jméno enumu, na základě někož provider vrátí správný enum. Pokud enum neexistuje vrací undefined. */
    enumName: string;
};

type StateProps = EnumProviderComponentChildrenProps;

const mapStateToProps: MapStateToProps<StateProps, EnumProviderProps, IAppState> = (state, { enumName }) => ({
    enumType: getEnumType(state, enumName),
});

export const EnumProvider = connect(mapStateToProps)(EnumProviderComponent);
